import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";
import { sanitizePathSegment } from "../utils/apiPathUtils";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const fetchPageLevelAccess = async (pageUrl) => {
  const safePageUrl = sanitizePathSegment(pageUrl);
  if (!safePageUrl) {
    return null;
  }

  try {
    const formData = {
      pageUrl: safePageUrl,
    };
    const response = await axiosInstance.post(
      "access/page-access-by-url/",
      formData,
      { headers }
    );
    return response.data.result;
  } catch (error) {
    console.error(
      "Error fetching access data:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};
